<template>
  <div class="p-col-12">

    <card :header="$t('forms.client.card-personal-information')" class="p-col-12" >
      <label-details :label="$t('forms.client.name')" :value="client.name" />
      <label-details :label="$t('forms.client.birthDay')" :value="$d(client.birthDay, 'short')" />
      <label-details :label="$t('forms.client.marriedDay')" :value="client.marriedDay ? $d(client.marriedDay, 'short') : null" />
<!--      <label-details :label="$t('forms.client.tags')" :value="client.tab" />-->
      <label-details :label="$t('forms.client.gender')" :value="client.gender ? $t(getGenderLabel(client.gender)) : null" />
      <label-details :label="$t(typeOfPersonSelected)" :value="client.document" />
      <label-details :label="$t('forms.client.rg')" :value="client.rg" />
      <label-details :label="$t('forms.client.maritalStatus')" :value="client.maritalStatus ? $t(getMaritalStatusLabel(client.maritalStatus)) : null" />
    </card>

    <card :header="$t('forms.client.card-relationship')" class="p-col-12" >
<!--      <label-details :label="$t('forms.client.mother')" :value="client.mother ? client.mother.name : ''" class="p-col-12 p-md-6 p-lg-6"/>-->
      <label-details :label="$t('forms.client.mother-name')" :value="client.motherName ? client.motherName : ''" class="p-col-12 p-md-6 p-lg-6"/>

<!--      <label-details :label="$t('forms.client.father')" :value="client.father ? client.father.name : ''" class="p-col-12 p-md-6 p-lg-6"/>-->
      <label-details :label="$t('forms.client.father-name')" :value="client.fatherName ? client.fatherName : ''" class="p-col-12 p-md-6 p-lg-6"/>
      <hr style="width: 100%"/>

      <div class="p-col-12">
        <h3>{{$t('forms.client.spouse')}}</h3>
        <label-details :label="$t('forms.client.spouse-name')" :value="client.spousesName ? client.spousesName : ''" class="p-col-12 p-md-6 p-lg-6"/>
        <div v-for="(spouse, index) in spousesSorted" :key="index">
          <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2" :class="{'spouses-success': isWeddingComplete(spouse),'spouses-warning': !isWeddingComplete(spouse), 'bold': spouse.current}">
              <div class="text-vertical-center">
                <span v-html="formattedSpouseInfo(spouse)"/>
              </div>
          </div>
        </div>
      </div>
    </card>

    <card :header="$t('forms.client.card-places-information')" class="p-col-12" >
        <label-details :label="$t('forms.client.birthCountry')" :value="getCountryLabel(client.birthCountry)" class="p-col-12 p-md-6 p-lg-4"/>
        <label-details :label="$t('forms.client.birthState')" :value="$t(getStateLabel(client.birthState))" v-if="client.birthCountry === 'BRASIL'" class="p-col-12 p-md-6 p-lg-4"/>
        <label-details :label="$t('forms.client.birthCity')" :value="client.birthCity" class="p-col-12 p-md-6 p-lg-4"/>
        <label-details :label="$t('forms.client.alive')" :value="client.alive ? $t('field.default.yes') : $t('field.default.no')" :show-double-dot="false" class="p-col-12" style="min-width: 100%"/>
        <template v-if="!client.alive">
            <label-details :label="$t('forms.client.deathDay')" :value="client.deathDay ? $d(client.deathDay, 'short') : null" />
            <label-details :label="$t('forms.client.deathCountry')" :value="getCountryLabel(client.deathCountry)" class="p-col-12 p-md-6 p-lg-4"/>
            <label-details :label="$t('forms.client.deathState')" :value="$t(getStateLabel(client.deathState))" v-if="client.deathCountry === 'BRASIL'" class="p-col-12 p-md-6 p-lg-4"/>
            <label-details :label="$t('forms.client.deathCity')" :value="client.deathCity" class="p-col-12 p-md-6 p-lg-4"/>
        </template>
    </card>

    <card :header="$t('forms.client.card-contact-information')" class="p-col-12" >
      <label-details :label="$t('forms.client.phoneNumber')" :value="client.phoneNumber"/>
      <label-details :label="$t('forms.client.cellPhoneNumber')" :value="client.cellPhoneNumber"/>
      <label-details :label="$t('forms.client.email')" :value="client.email"/>
    </card>

    <card :header="$t('forms.address.card-information')" class="p-col-12" >
      <label-details :label="$t('forms.address.country')" :value="$t(getCountryLabel(client.address.country))"/>
      <label-details :label="$t('forms.address.zipCode')" :value="client.address.zipCode"/>
      <label-details :label="$t('forms.address.state')" :value="$t(getStateLabel(client.address.state))" v-if="client.address.country === 'BRASIL'"/>
      <label-details :label="$t('forms.address.state')" :value="client.address.foreignState" v-else/>
      <label-details :label="$t('forms.address.city')" :value="client.address.city"/>
      <label-details :label="$t('forms.address.district')" :value="client.address.district"/>
      <label-details :label="$t('forms.address.street')" :value="client.address.street"/>
      <label-details :label="$t('forms.address.number')" :value="client.address.number"/>
      <label-details :label="$t('forms.address.complement')" :value="client.address.complement"/>
    </card>

  </div>

</template>

<script>
import LabelDetails from "@/components/LabelDetails";
import ClientBusiness from "@/business/ClientBusiness";
import AddressBusiness from "@/business/AddressBusiness";
import CountryBusiness from "@/business/CountryBusiness";
export default {
  name: "ClientDetails",
  components: {LabelDetails},

  props:{
    client: {type: Object, default: () => {return {}}},
  },

  computed: {

    typeOfPersonSelected(){
      return !this.client.typeOfPerson ? 'forms.client.document' : this.client.typeOfPerson === 'PERSON' ? 'forms.client.cpf' : 'forms.client.cnpj';
    },

    spousesSorted(){
      return [...this.client.spouses]
                .filter(s => s.date !== null)
                .sort((a, b) => (b.date || 0) - (a.date || 0));
    },

  },

  methods: {

    getMaritalStatusLabel: ClientBusiness.getMaritalStatusLabel,
    getGenderLabel: ClientBusiness.getGenderLabel,
    getStateLabel: AddressBusiness.getStateLabel,
    getCountryLabel: CountryBusiness.getCountryLabel,

    getSpouse(spouse){
      return this.client.id === spouse.spouseA?.id ? spouse.spouseB : spouse.spouseA;
    },

    formattedSpouseInfo(spouse) {
      return `${this.$t('forms.client.wedding-current')} 
              ${spouse.current ? this.$t('field.default.yes') : this.$t('field.default.no')},
              ${this.$t('forms.client.marriedDay')}: 
              ${spouse.date ? this.$d(spouse.date, 'short') : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`},
              ${this.$t('forms.client.spouse')}: <a class="cursor-pointer" target="_blank" href="#/client/${this.getSpouse(spouse).id}/details">${this.getSpouse(spouse).name}</a><br/>
              ${this.$t('forms.client.weddingCountry')}: ${spouse.weddingCountry ? this.getCountryLabel(spouse.weddingCountry) : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`},
              ${spouse.weddingCountry === 'BRASIL'  ? (this.$t('forms.client.weddingState')+': ' + (this.isStateComplete(spouse) ? this.$t(this.getStateLabel(spouse.weddingState)) : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`) +',') : ''}
              ${this.$t('forms.client.weddingCity')}: ${spouse.weddingCity ? spouse.weddingCity : `<span class="coff-input-error">${this.$t('forms.client.notPresent')}</span>`}
              `;
    },

    isWeddingComplete(spouse) {
      return this.isStateComplete(spouse) && spouse.weddingCountry && spouse.weddingCity && spouse.date;
    },

    isStateComplete(spouse) {
      return (spouse.weddingState && spouse.weddingCountry === 'BRASIL')
    }
  }

}
</script>

<style scoped>

.spouses-success {
  background-color: #8cd795;
}

.spouses-warning {
  background-color: #efc46f;
}

</style>